import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./TooltipStyle.scss";
const TooltipButton = ({
  children,
  type = "array",
  keyValue,
  placement = "top",
  tooltipMessage,
  classes,
}) => {
  return (
    <OverlayTrigger
      key={keyValue}
      placement={placement}
      overlay={
        type === "array" ? (
          <Tooltip id={keyValue}>
            {tooltipMessage.map((item) => (
              <span>{item}, </span>
            ))}
          </Tooltip>
        ) : (
          <Tooltip id={keyValue} className={classes}>
            {tooltipMessage}
          </Tooltip>
        )
      }
    >
      <span className="cursor-pointer">{children}</span>
    </OverlayTrigger>
  );
};

export default TooltipButton;
